// extracted by mini-css-extract-plugin
export default {"addForm":"profile_addForm__0EDMx","formControl":"profile_formControl__p4o8Z","list":"profile_list__h1gDM","btnWrpper":"profile_btnWrpper__AHl9U"};